import { ITokenNewsItem } from '@kattana-io/common';
import Text from '../../atoms/Text';
import { timeDistance } from '../DexTrades/formatters';

interface INewsProps {
  news: ITokenNewsItem[];
}

const News = ({ news }: INewsProps) => {
  return (
    <div className='seo_page__news'>
      <div className='seo_page__news__content'>
        <div className='seo_page__news__title'>
          <Text size={18} className='text--grey-200 text--weight-500'>
            Last News
          </Text>
        </div>
        <div className='seo_page__news__list'>
          {news.slice(0, 3).map((item) => {
            return (
              <a
                key={item.ID}
                href={item.Link}
                className='seo_page__news__list__item'
                target='_blank'
                rel='noreferrer'
              >
                <Text size={14} className='text--white text--weight-600'>
                  {item.Text.split(/[\n\s]/)
                    .slice(0, 8)
                    .join('\n')}
                  ...
                </Text>
                <Text size={12} className='text--grey-600 text--weight-500'>
                  {item.Hash.includes('twit') ? 'Twitter · ' : ''}
                  {timeDistance(item.CreatedAt)} ago
                </Text>
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default News;
